import { useQueryClient } from '@tanstack/react-query';
import { useAccountFeaturesQuery, useAccountSummaryV2Query as useAccountSummaryQuery, useCreditAccountsQuery } from 'syf-api';
import { useAllAccountSummaryQuery } from 'syf-api/allAccountSummary';
import { useConfig } from '../hooks/use-config';
import { useAuthorizedUsersGetQuery } from '../services/authorized-users/get/use-authorized-users-get-query';
import { useAuthorizedUsersPostMutation } from '../services/authorized-users/post/use-authorized-users-post-mutation';
import { useChangePaymentDueDateGetQuery } from '../services/change-payment-due-date';
import { useChangePaymentDueDatePutMutation } from '../services/change-payment-due-date/put/use-change-payment-due-date-put-mutation';
import { useAuthorizedBuyersLookupGetQuery } from '../services/authorized-buyers/use-authorized-buyer-get-lookup-query';
import getApiConfig from '../helpers/get-api-config';
const useCreditAccounts = () => {
    const queryClient = useQueryClient();
    const mfeConfig = useConfig();
    const enabledQuery = Boolean(sessionStorage.getItem('accessToken'));
    const apiConfig = getApiConfig(queryClient, mfeConfig, enabledQuery);
    return useCreditAccountsQuery({
        keyProps: undefined,
        ...apiConfig
    });
};
const useAllAccountSummary = (accounts) => {
    const keyProps = accounts.map(account => {
        return {
            accountId: account.info['cipher.accountId'],
            accountIdType: account?.info?.accountIdType
        };
    });
    const queryClient = useQueryClient();
    const mfeConfig = useConfig();
    const apiConfig = getApiConfig(queryClient, mfeConfig, Boolean(accounts.length));
    return useAllAccountSummaryQuery({
        keyProps,
        ...apiConfig
    });
};
const useAccountSummary = (accountId) => {
    const queryClient = useQueryClient();
    const mfeConfig = useConfig();
    const apiConfig = getApiConfig(queryClient, mfeConfig, Boolean(accountId));
    return useAccountSummaryQuery({
        keyProps: { accountId, accountIdType: 'guid' },
        ...apiConfig
    });
};
const useAccountFeatures = (accountId) => {
    const queryClient = useQueryClient();
    const mfeConfig = useConfig();
    const apiConfig = getApiConfig(queryClient, mfeConfig, Boolean(accountId));
    return useAccountFeaturesQuery({
        keyProps: { accountId, accountIdType: 'guid' },
        ...apiConfig
    });
};
const useAuthorizedUsersGet = (accountId) => {
    const queryClient = useQueryClient();
    const mfeConfig = useConfig();
    const apiConfig = getApiConfig(queryClient, mfeConfig, Boolean(accountId));
    return useAuthorizedUsersGetQuery({
        keyProps: { accountId, accountIdType: 'guid' },
        ...apiConfig
    });
};
const useMultiAuthorizedUsersPostMutation = (config) => {
    const queryClient = useQueryClient();
    const enabledMutation = Boolean(sessionStorage.getItem('accessToken'));
    const apiConfig = getApiConfig(queryClient, config, enabledMutation);
    return useAuthorizedUsersPostMutation({
        keyProps: undefined,
        ...apiConfig
    });
};
const useChangePaymentDueDateGet = (accountId) => {
    const queryClient = useQueryClient();
    const mfeConfig = useConfig();
    const apiConfig = getApiConfig(queryClient, mfeConfig, Boolean(accountId));
    return useChangePaymentDueDateGetQuery({
        keyProps: { accountId, accountIdType: 'guid' },
        ...apiConfig
    });
};
const useChangePaymentDueDatePut = (config) => {
    const queryClient = useQueryClient();
    const enabledMutation = Boolean(sessionStorage.getItem('accessToken'));
    const apiConfig = getApiConfig(queryClient, config, enabledMutation);
    return useChangePaymentDueDatePutMutation({
        keyProps: undefined,
        ...apiConfig
    });
};
const useAuthorizedBuyersLookupGet = ({ lookupRequestData, isEnabled }) => {
    const { creditType, membershipNumber, productType } = lookupRequestData;
    const queryClient = useQueryClient();
    const mfeConfig = useConfig();
    const apiConfig = getApiConfig(queryClient, mfeConfig, isEnabled);
    const productTypeFormatted = productType === 'PRIVATE_LABEL' ? 'PLCC' : 'MASTERCARD';
    return useAuthorizedBuyersLookupGetQuery({
        keyProps: {
            creditType,
            membershipNumber,
            productType: productTypeFormatted
        },
        ...apiConfig
    });
};
export { useAccountFeatures, useAccountSummary, useAllAccountSummary, useAuthorizedBuyersLookupGet, useAuthorizedUsersGet, useChangePaymentDueDateGet, useChangePaymentDueDatePut, useCreditAccounts, useMultiAuthorizedUsersPostMutation };
